import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Content } from '../../../../components/Header/components/MainContainer/Content.js';
import { Inner } from '../../../../components/Header/components/MainContainer/Inner.js';
export const MainContainer = ({
  children
}) => {
  return _jsx(Content, {
    children: _jsx(Inner, {
      children: children
    })
  });
};